attachEvent('.sidebar__arrow', 'click', (arrow) => {
  const parent = arrow.target.closest('.sidebar__item');
  const dropdown = parent.querySelector('.sidebar__dropdown');

  parent.classList.toggle('is-open');

  if (parent.classList.contains('is-open')) {
    slideDown(dropdown, 300);
  } else {
    slideUp(dropdown, 300);
  }
});
